import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-business-list',
  templateUrl: './business-list.component.html',
  styleUrls: ['./business-list.component.sass']
})
export class BusinessListComponent implements OnInit {

  items;
  docId;
  logoImage: string = "./assets/img/no-logo.png"

  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public firestore: FirestoreService
  ) { }

  ngOnInit(): void {
    this.docId = this.aroute.snapshot.paramMap.get('id');
    this.items = this.firestore.getBusinessLists(this.docId);
  };

  routeToBusinessDetailPage(docId){
    this.route.navigateByUrl('business/'+docId);
  };

  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }
}